import { createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeClass as _normalizeClass, vShow as _vShow, resolveComponent as _resolveComponent, createBlock as _createBlock, createTextVNode as _createTextVNode, createVNode as _createVNode, withCtx as _withCtx } from "vue"
import _imports_0 from '../../../../assets/images/lock.svg'
import _imports_1 from '../../../../assets/images/default-map-usa.png'


const _hoisted_1 = {
  id: "Clinician__Tasks",
  class: "dashboard-card d-flex"
}
const _hoisted_2 = { class: "d-flex flex-column card-title w-100 pe-2 pb-0" }
const _hoisted_3 = { class: "d-flex align-items-center justify-content-between fw-bold font-size-md w-100 position-relative" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", null, " Visits ", -1 /* HOISTED */)
const _hoisted_5 = { key: 0 }
const _hoisted_6 = {
  tabindex: "0",
  href: "javascript:void(0);",
  role: "button"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-info-circle text-primary ms-1" }, null, -1 /* HOISTED */)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = { class: "d-flex align-items-center justify-content-start date-toggle-container" }
const _hoisted_10 = {
  key: 0,
  class: "mx-2 font-size-sm fw-bold"
}
const _hoisted_11 = {
  key: 1,
  class: "mx-2 font-size-sm fw-bold"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-spinner fa-pulse fa-fw" }, null, -1 /* HOISTED */)
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", null, " Route Visits ", -1 /* HOISTED */)
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = {
  key: 1,
  class: "ai-border ai-disabled"
}
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", null, " Route Visits ", -1 /* HOISTED */)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1 /* HOISTED */)
const _hoisted_19 = [
  _hoisted_17,
  _hoisted_18
]
const _hoisted_20 = { class: "calendar-no-visits-vue text-dark mt-2" }
const _hoisted_21 = {
  ref: "noVisitDatePicker",
  class: "schedule-calendar"
}
const _hoisted_22 = {
  key: 1,
  class: "img-map-container"
}
const _hoisted_23 = /*#__PURE__*/_createElementVNode("img", {
  class: "me-1",
  src: _imports_1
}, null, -1 /* HOISTED */)
const _hoisted_24 = [
  _hoisted_23
]
const _hoisted_25 = { class: "mt-3 text-center" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-spinner fa-pulse fa-fw" }, null, -1 /* HOISTED */)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("b", null, "Loading your Visits", -1 /* HOISTED */)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-spinner fa-pulse fa-fw" }, null, -1 /* HOISTED */)
const _hoisted_29 = [
  _hoisted_26,
  _hoisted_27,
  _hoisted_28
]
const _hoisted_30 = { class: "mt-5 text-center" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" There was a problem while fetching your Visits Schedule. "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Please try again. ")
], -1 /* HOISTED */)
const _hoisted_32 = {
  key: 2,
  class: "no-data"
}
const _hoisted_33 = { class: "mb-3 text-center text-gray mt-n2" }
const _hoisted_34 = { key: 0 }
const _hoisted_35 = { key: 3 }
const _hoisted_36 = { class: "router-task position-relative" }
const _hoisted_37 = { class: "d-flex flex-column align-items-center justify-content-center me-3 text-danger fw-bold" }
const _hoisted_38 = { class: "d-flex flex-column flex-grow-1" }
const _hoisted_39 = { class: "d-flex align-items-center justify-content-between" }
const _hoisted_40 = { class: "font-size-xs mb-1 fw-bold" }
const _hoisted_41 = {
  key: 0,
  class: "pill-oncall pill me-2"
}
const _hoisted_42 = {
  key: 1,
  class: "pill-prn pill me-2"
}
const _hoisted_43 = {
  key: 2,
  class: "me-2"
}
const _hoisted_44 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-check-circle confirmed-check me-1" }, null, -1 /* HOISTED */)
const _hoisted_45 = /*#__PURE__*/_createElementVNode("span", { class: "confirmed-text" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Confirmed")
], -1 /* HOISTED */)
const _hoisted_46 = [
  _hoisted_44,
  _hoisted_45
]
const _hoisted_47 = {
  key: 3,
  class: "me-2"
}
const _hoisted_48 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-exclamation-circle reschedule-status me-1" }, null, -1 /* HOISTED */)
const _hoisted_49 = /*#__PURE__*/_createElementVNode("span", { class: "reschedule-status" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Reschedule")
], -1 /* HOISTED */)
const _hoisted_50 = [
  _hoisted_48,
  _hoisted_49
]
const _hoisted_51 = { class: "font-size-xs" }
const _hoisted_52 = { class: "d-flex align-items-center fw-bold" }
const _hoisted_53 = ["onClick"]
const _hoisted_54 = {
  key: 0,
  class: "fas fa-birthday-cake"
}
const _hoisted_55 = /*#__PURE__*/_createElementVNode("div", { class: "position-absolute top-3 dragger" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "drag-icon" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fas fa-exchange-alt font-size-3xs" })
  ])
], -1 /* HOISTED */)
const _hoisted_56 = { class: "font-size-xs" }
const _hoisted_57 = { key: 0 }
const _hoisted_58 = { key: 1 }
const _hoisted_59 = { class: "font-size-xs my-1" }
const _hoisted_60 = ["href"]
const _hoisted_61 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_62 = { class: "d-flex align-items-center" }
const _hoisted_63 = { class: "text-default ms-2 font-size-2xs" }
const _hoisted_64 = { class: "right-section d-flex align-items-center" }
const _hoisted_65 = {
  key: 0,
  class: "fas fa-sticky-note orange-note me-2"
}
const _hoisted_66 = {
  key: 1,
  class: "me-2 fas fa-sticky-note red-note"
}
const _hoisted_67 = {
  key: 2,
  class: "me-2 fas fa-sticky-note blue-note"
}
const _hoisted_68 = {
  key: 3,
  class: "me-2 fas fa-sticky-note yellow-note"
}
const _hoisted_69 = ["onClick"]
const _hoisted_70 = ["onClick"]
const _hoisted_71 = ["onClick"]
const _hoisted_72 = { class: "dropdown app-menu ms-2" }
const _hoisted_73 = /*#__PURE__*/_createElementVNode("a", {
  class: "text-dark fw-bold font-size-sm",
  href: "javascript:void(0);",
  id: "User_Dropdown",
  role: "button",
  "aria-haspopup": "true",
  "aria-expanded": "false"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-ellipsis-h ellipsis" })
], -1 /* HOISTED */)
const _hoisted_74 = {
  class: "dropdown-menu dropdown-menu-end mt-0 font-size-xs text-center",
  "aria-labelledby": "User_Dropdown"
}
const _hoisted_75 = ["onClick"]
const _hoisted_76 = /*#__PURE__*/_createElementVNode("span", null, "Details", -1 /* HOISTED */)
const _hoisted_77 = [
  _hoisted_76
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TasksMap = _resolveComponent("TasksMap")!
  const _component_ProductPill = _resolveComponent("ProductPill")!
  const _component_draggable = _resolveComponent("draggable")!
  const _component_CardTemplate = _resolveComponent("CardTemplate")!
  const _directive_custom_popover = _resolveDirective("custom-popover")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(_component_CardTemplate, {
      borderClass: `task-section ${_ctx.isTaskList ? '' : 'py-2'}`
    }, {
      header: _withCtx(() => [
        _createElementVNode("section", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", {
              class: _normalizeClass(`${_ctx.isTaskList ? 'task-list-full' : 'task-list-empty'}`)
            }, [
              _hoisted_4,
              (_ctx.taskList.length)
                ? (_openBlock(), _createElementBlock("span", _hoisted_5, " (" + _toDisplayString(_ctx.taskList.length) + ") ", 1 /* TEXT */))
                : _createCommentVNode("v-if", true),
              _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_6, _hoisted_8)), [
                [_directive_custom_popover, { content: _ctx.tooltip, className: 'w-30 font-size-sm info-popup' }]
              ])
            ], 2 /* CLASS */),
            _createElementVNode("div", _hoisted_9, [
              _withDirectives(_createElementVNode("i", {
                class: _normalizeClass(
                                    'fas fa-chevron-left cursor-pointer' +
                                    `${_ctx.decrementDisabled ? 'no-navigation' : ''} ${_ctx.isLoading ? 'disabled' : ''}`
                                ),
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.decrementTaskDate()))
              }, null, 2 /* CLASS */), [
                [_directive_tooltip, { title: _ctx.bwdNavTooltip }]
              ]),
              (!_ctx.isLoading && _ctx.myTasksDate)
                ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(_ctx.formatDate(_ctx.myTasksDate.toString(), "ddd, DD MMM , YYYY")), 1 /* TEXT */))
                : _createCommentVNode("v-if", true),
              (_ctx.isLoading)
                ? (_openBlock(), _createElementBlock("span", _hoisted_11, _hoisted_13))
                : _createCommentVNode("v-if", true),
              _createElementVNode("span", {
                class: "calendar-icon d-flex justify-content-center align-items-center",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleCalendar && _ctx.toggleCalendar(...args)))
              }, [
                _createElementVNode("i", {
                  class: _normalizeClass(`fas fa-calendar-alt ${_ctx.showCalendar == true ? 'active' : ''}`)
                }, null, 2 /* CLASS */)
              ]),
              _withDirectives(_createElementVNode("i", {
                class: _normalizeClass(
                                    'fas fa-chevron-right cursor-pointer ps-1' +
                                    ` ${_ctx.incrementDisabled ? 'no-navigation' : ''} ${_ctx.isLoading ? 'disabled' : ''}`
                                ),
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.incrementTaskDate()))
              }, null, 2 /* CLASS */), [
                [_directive_tooltip, { title: _ctx.fwdNavTooltip }]
              ])
            ]),
            _createElementVNode("div", {
              class: "text-center text-lg-end",
              onMouseover: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showLogo(_ctx.isAnyPremiumAgency ? true : false))),
              onMouseout: _cache[5] || (_cache[5] = ($event: any) => (_ctx.showLogo(false)))
            }, [
              (_ctx.isAnyPremiumAgency && _ctx.isTaskList)
                ? _withDirectives((_openBlock(), _createElementBlock("div", {
                    key: 0,
                    onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.routeVisits && _ctx.routeVisits(...args))),
                    class: "ai-border"
                  }, _hoisted_15)), [
                    [_directive_tooltip, { title: _ctx.routeVisitTooltip, placement: 'right' }]
                  ])
                : _createCommentVNode("v-if", true),
              (!_ctx.isAnyPremiumAgency && _ctx.isTaskList)
                ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_16, _hoisted_19)), [
                    [_directive_tooltip, {
                                    title: `Contact Axxess to unlock this <br /> premium Axxess intelligence feature.`,
                                    placement: 'top',
                                    className: 'lock-premium'
                                }]
                  ])
                : _createCommentVNode("v-if", true)
            ], 32 /* HYDRATE_EVENTS */)
          ])
        ])
      ]),
      content: _withCtx(() => [
        _createElementVNode("section", {
          ref: "tasksContainerRef",
          class: _normalizeClass(["w-100 h-100 overflow-auto pb-2", `${_ctx.userOs == 'Windows' ? 'custom-scrollbar' : ''}`])
        }, [
          _withDirectives(_createElementVNode("div", _hoisted_20, [
            _createElementVNode("div", _hoisted_21, null, 512 /* NEED_PATCH */)
          ], 512 /* NEED_PATCH */), [
            [_vShow, _ctx.showCalendar]
          ]),
          (_ctx.taskList.length > 0)
            ? (_openBlock(), _createBlock(_component_TasksMap, {
                key: 0,
                "my-task-date": _ctx.myTasksDate,
                "task-list": _ctx.taskList,
                "selected-task": _ctx.selectedTask,
                onSelectedTaskChanged: _ctx.selectedTaskChanged,
                "list-update": _ctx.listUpdate
              }, null, 8 /* PROPS */, ["my-task-date", "task-list", "selected-task", "onSelectedTaskChanged", "list-update"]))
            : (_openBlock(), _createElementBlock("div", _hoisted_22, _hoisted_24)),
          _createCommentVNode(" LOADING "),
          _withDirectives(_createElementVNode("div", _hoisted_25, _hoisted_29, 512 /* NEED_PATCH */), [
            [_vShow, _ctx.isLoading && !_ctx.hasError]
          ]),
          _createCommentVNode(" ERROR "),
          _withDirectives(_createElementVNode("div", _hoisted_30, [
            _hoisted_31,
            _createElementVNode("button", {
              class: "btn btn-primary",
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.getTasks()))
            }, "Try Again")
          ], 512 /* NEED_PATCH */), [
            [_vShow, _ctx.hasError && !_ctx.isLoading]
          ]),
          _createCommentVNode(" NO DATA "),
          (_ctx.taskList.length === 0 && !_ctx.isLoading && !_ctx.hasError)
            ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                _createElementVNode("i", _hoisted_33, [
                  _createTextVNode(" You have no visits scheduled " + _toDisplayString(_ctx.isPresent ? "today." : "on") + " ", 1 /* TEXT */),
                  (!_ctx.isPresent)
                    ? (_openBlock(), _createElementBlock("b", _hoisted_34, _toDisplayString(_ctx.formatDate(_ctx.myTasksDate.toString(), "MMMM DD, YYYY")), 1 /* TEXT */))
                    : _createCommentVNode("v-if", true)
                ])
              ]))
            : _createCommentVNode("v-if", true),
          _createCommentVNode(" DATA "),
          (!_ctx.isLoading && !_ctx.hasError && _ctx.taskList.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                _createVNode(_component_draggable, {
                  list: _ctx.taskList,
                  handle: ".dragger",
                  ghostClass: "ghost",
                  onStart: _cache[7] || (_cache[7] = ($event: any) => (_ctx.dragging = true)),
                  onEnd: _cache[8] || (_cache[8] = ($event: any) => (_ctx.dragging = false)),
                  onChange: _cache[9] || (_cache[9] = ($event: any) => (_ctx.orderChanged(_ctx.taskList))),
                  "item-key": "id"
                }, {
                  item: _withCtx(({ element: task }) => [
                    _createElementVNode("div", _hoisted_36, [
                      _createElementVNode("div", _hoisted_37, [
                        _createElementVNode("p", null, _toDisplayString(task.key), 1 /* TEXT */)
                      ]),
                      _createElementVNode("section", _hoisted_38, [
                        _createElementVNode("div", _hoisted_39, [
                          _createElementVNode("div", null, [
                            _createElementVNode("span", _hoisted_40, _toDisplayString(task.VisitName), 1 /* TEXT */)
                          ]),
                          _createElementVNode("div", null, [
                            (task.OnCall)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_41, " On-Call "))
                              : _createCommentVNode("v-if", true),
                            (task.PRN)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_42, " PRN "))
                              : _createCommentVNode("v-if", true),
                            (task.VisitConfirmed)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_43, _hoisted_46))
                              : _createCommentVNode("v-if", true),
                            _createCommentVNode(" <span v-if=\"task.PatientCalled\" class=\"me-2\">\r\n                                                    <i class=\"fas fa-exclamation-circle call-office-status me-1\"></i>\r\n                                                    <span class=\"call-office-status\"\r\n                                                        ><strong>Call the Office</strong></span\r\n                                                    >\r\n                                                </span> "),
                            _createCommentVNode(" commented code will need in future "),
                            (task.PatientCalled)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_47, _hoisted_50))
                              : _createCommentVNode("v-if", true),
                            _createCommentVNode(" using 'CalledPatient' temporary until we get veriable for \"Call To Reschedule\" from Solution  "),
                            _createElementVNode("span", _hoisted_51, _toDisplayString(_ctx.formatVisitTime(
                                                            new Date(task.StartDateTime),
                                                            new Date(task.EndDateTime)
                                                        )), 1 /* TEXT */)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_52, [
                          _createElementVNode("a", {
                            href: "javascript:void(0);",
                            onClick: ($event: any) => (_ctx.viewPatient(task)),
                            class: "me-1"
                          }, _toDisplayString(task.patientFullName), 9 /* TEXT, PROPS */, _hoisted_53),
                          (task.isPatientBirthDate)
                            ? _withDirectives((_openBlock(), _createElementBlock("i", _hoisted_54, null, 512 /* NEED_PATCH */)), [
                                [_directive_tooltip, { title: task.birthDateTooltip }]
                              ])
                            : _createCommentVNode("v-if", true),
                          _hoisted_55
                        ]),
                        _createElementVNode("div", _hoisted_56, [
                          (
                                                    (task.Application === _ctx.ApplicationEnum.AxxessHospiceFE ||
                                                        task.Application === _ctx.ApplicationEnum.AxxessPalliative) &&
                                                    task.IsMissedVisit
                                                )
                            ? (_openBlock(), _createElementBlock("span", _hoisted_57, " Missed Visit (" + _toDisplayString(task.StatusName) + ") ", 1 /* TEXT */))
                            : (_openBlock(), _createElementBlock("span", _hoisted_58, _toDisplayString(task.StatusName), 1 /* TEXT */))
                        ]),
                        _createElementVNode("div", _hoisted_59, [
                          _createElementVNode("span", null, [
                            _createTextVNode(_toDisplayString(task.fullAddress) + " " + _toDisplayString(task.PatientPhoneNumber ? "-" : "") + " ", 1 /* TEXT */),
                            (task.PatientPhoneNumber)
                              ? (_openBlock(), _createElementBlock("a", {
                                  key: 0,
                                  href: 'tel:' + task.PatientPhoneNumber,
                                  class: "mb-0 font-size-xs w-auto"
                                }, _toDisplayString(_ctx.formatPhone(task.PatientPhoneNumber)), 9 /* TEXT, PROPS */, _hoisted_60))
                              : _createCommentVNode("v-if", true)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_61, [
                          _createElementVNode("div", _hoisted_62, [
                            _createVNode(_component_ProductPill, {
                              class: "align-self-start",
                              "product-id": _ctx.getApplicationId(task.Application)
                            }, null, 8 /* PROPS */, ["product-id"]),
                            _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_63, [
                              _createTextVNode(_toDisplayString(task.BranchName), 1 /* TEXT */)
                            ])), [
                              [_directive_tooltip, { title: task.agencyTooltip, placement: 'top' }]
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_64, [
                            (_ctx.isOrange(task))
                              ? _withDirectives((_openBlock(), _createElementBlock("i", _hoisted_65, null, 512 /* NEED_PATCH */)), [
                                  [_directive_tooltip, {
                                                        title: task.ReturnComments,
                                                        placement: 'right',
                                                        className: 'orange-note'
                                                    }]
                                ])
                              : _createCommentVNode("v-if", true),
                            (_ctx.isRed(task) && task.Status !== '405')
                              ? _withDirectives((_openBlock(), _createElementBlock("i", _hoisted_66, null, 512 /* NEED_PATCH */)), [
                                  [_directive_tooltip, {
                                                        title: _ctx.redToolTip(task),
                                                        placement: 'right',
                                                        className: 'red-note'
                                                    }]
                                ])
                              : _createCommentVNode("v-if", true),
                            (task.EpisodeNotes?.length)
                              ? _withDirectives((_openBlock(), _createElementBlock("i", _hoisted_67, null, 512 /* NEED_PATCH */)), [
                                  [_directive_tooltip, {
                                                        title: task.EpisodeNotes,
                                                        placement: 'right',
                                                        className: 'blue-note'
                                                    }]
                                ])
                              : _createCommentVNode("v-if", true),
                            (_ctx.showComments(task))
                              ? _withDirectives((_openBlock(), _createElementBlock("i", _hoisted_68, null, 512 /* NEED_PATCH */)), [
                                  [_directive_tooltip, {
                                                        title: task.Comments,
                                                        placement: 'right',
                                                        className: 'yellow-note'
                                                    }]
                                ])
                              : _createCommentVNode("v-if", true),
                            (
                                                        task.statusNameType &&
                                                        !_ctx.isMissedVisit(task.Status) &&
                                                        _ctx.isHomeCare(task) &&
                                                        _ctx.isFutureDocumentationPreventedHC(task) &&
                                                        _ctx.checkPermission(
                                                            task.statusNameType,
                                                            task.Application,
                                                            task.AgencyId
                                                        ) &&
                                                        !_ctx.isHosOrPal(task.Application)
                                                    )
                              ? _withDirectives((_openBlock(), _createElementBlock("button", {
                                  key: 4,
                                  href: "javascript:void(0);",
                                  onClick: ($event: any) => (_ctx.startTask(task)),
                                  class: _normalizeClass(`btn btn-primary ${task.statusNameType}`)
                                }, [
                                  _createTextVNode(_toDisplayString(task.statusNameType), 1 /* TEXT */)
                                ], 10 /* CLASS, PROPS */, _hoisted_69)), [
                                  [_directive_tooltip, { title: task.buttonTooltip }]
                                ])
                              : (
                                                        task.statusNameType &&
                                                        !_ctx.isMissedVisit(task.Status) &&
                                                        !_ctx.isFuture() &&
                                                        _ctx.checkPermission(
                                                            task.statusNameType,
                                                            task.Application,
                                                            task.AgencyId
                                                        ) &&
                                                        !_ctx.isHosOrPal(task.Application)
                                                    )
                                ? _withDirectives((_openBlock(), _createElementBlock("button", {
                                    key: 5,
                                    href: "javascript:void(0);",
                                    onClick: ($event: any) => (_ctx.startTask(task)),
                                    class: _normalizeClass(`btn btn-primary ${task.statusNameType}`)
                                  }, [
                                    _createTextVNode(_toDisplayString(task.statusNameType), 1 /* TEXT */)
                                  ], 10 /* CLASS, PROPS */, _hoisted_70)), [
                                    [_directive_tooltip, { title: task.buttonTooltip }]
                                  ])
                                : _createCommentVNode("v-if", true),
                            (
                                                        task.statusNameHosPal &&
                                                        _ctx.showFutureVisit(task.IsFutureDocumentationPrevented) &&
                                                        !(task.Application === _ctx.ApplicationEnum.AxxessPalliative
                                                            ? task.IsMissed
                                                            : task.IsMissedVisit) &&
                                                        _ctx.checkPermission(
                                                            task.statusNameHosPal,
                                                            task.Application,
                                                            task.AgencyId
                                                        ) &&
                                                        _ctx.isHosOrPal(task.Application)
                                                    )
                              ? _withDirectives((_openBlock(), _createElementBlock("button", {
                                  key: 6,
                                  href: "javascript:void(0);",
                                  onClick: ($event: any) => (_ctx.startHosPalTask(task)),
                                  class: _normalizeClass(`btn btn-primary isPendingApproval ${
                                                        task.statusNameHosPal == 'Pending Approval' ? 'disabled' : ''
                                                    }`)
                                }, [
                                  _createElementVNode("span", null, _toDisplayString(task.statusNameHosPal), 1 /* TEXT */)
                                ], 10 /* CLASS, PROPS */, _hoisted_71)), [
                                  [_directive_tooltip, { title: task.buttonTooltip }]
                                ])
                              : _createCommentVNode("v-if", true),
                            _createElementVNode("span", _hoisted_72, [
                              _hoisted_73,
                              _createElementVNode("div", _hoisted_74, [
                                _createElementVNode("a", {
                                  href: "javascript:void(0);",
                                  onClick: ($event: any) => (_ctx.openVisitDetails(task))
                                }, _hoisted_77, 8 /* PROPS */, _hoisted_75)
                              ])
                            ])
                          ])
                        ])
                      ])
                    ])
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["list"])
              ]))
            : _createCommentVNode("v-if", true)
        ], 2 /* CLASS */)
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["borderClass"])
  ]))
}